import ActionUtility from "../../utilities/ActionUtility";
import StatusEffect from "./StatusEffect";

export default class StatusAction {
  // StatusAction action with an function declaration
  static REQUEST_STATUS = "StatusAction.REQUEST_STATUS";
  static REQUEST_STATUS_FINISHED = "StatusAction.REQUEST_STATUS_FINISHED";

  static REQUEST_STATUS_FILTER = "StatusAction.REQUEST_STATUS_FILTER";
  static REQUEST_STATUS_FILTER_FINISHED =
    "StatusAction.REQUEST_STATUS_FILTER_FINISHED";

  // METHODS
  // Organization GET function
  static requestStatus(params) {
    return async (dispatch, getState) => {
      await ActionUtility.createThunkEffect(
        dispatch,
        StatusAction.REQUEST_STATUS,
        StatusEffect.requestStatus,
        params
      );
    };
  }

  static requestStatusFilter(params) {
    return async (dispatch, getState) => {
      await ActionUtility.createThunkEffect(
        dispatch,
        StatusAction.REQUEST_STATUS_FILTER,
        StatusEffect.requestStatusFilter,
        params
      );
    };
  }
}
